
import React from 'react';
import { motion } from 'framer-motion';
import { TabsList, TabsTrigger } from '@/components/ui/tabs';
import { UserRound, User } from 'lucide-react';

interface GenderTabsProps {
  gender: 'male' | 'female';
  onGenderChange: (value: string) => void;
}

const GenderTabs: React.FC<GenderTabsProps> = ({ gender, onGenderChange }) => {
  return (
    <div className="flex justify-center mb-6">
      <TabsList className="grid grid-cols-2 w-full max-w-md border-2 shadow-lg">
        <TabsTrigger 
          value="male"
          onClick={() => onGenderChange('male')}
          className={`relative data-[state=active]:font-bold py-3 ${
            gender === 'male' 
              ? 'bg-gradient-to-r from-blue-500 to-blue-400 text-white data-[state=active]:text-white shadow-md ring-2 ring-blue-300' 
              : 'bg-blue-50 hover:bg-blue-100 text-blue-900'
          } transition-all duration-300`}
        >
          <motion.div 
            animate={{ scale: gender === 'male' ? [1, 1.1, 1] : 1 }}
            transition={{ duration: 0.5 }}
            className="flex items-center gap-2"
          >
            <UserRound className={gender === 'male' ? 'text-white' : 'text-blue-700'} size={18} />
            <span>Nam</span>
          </motion.div>
        </TabsTrigger>
        
        <TabsTrigger 
          value="female" 
          onClick={() => onGenderChange('female')}
          className={`relative data-[state=active]:font-bold py-3 ${
            gender === 'female' 
              ? 'bg-gradient-to-r from-pink-400 to-pink-300 text-white data-[state=active]:text-white shadow-md ring-2 ring-pink-200' 
              : 'bg-pink-50 hover:bg-pink-100 text-pink-900'
          } transition-all duration-300`}
        >
          <motion.div 
            animate={{ scale: gender === 'female' ? [1, 1.1, 1] : 1 }}
            transition={{ duration: 0.5 }}
            className="flex items-center gap-2"
          >
            <User className={gender === 'female' ? 'text-white' : 'text-pink-700'} size={18} />
            <span>Nữ</span>
          </motion.div>
        </TabsTrigger>
      </TabsList>
    </div>
  );
};

export default GenderTabs;
